namespace SPA
{
	export namespace pattern
	{

		export interface IInputUIDefinition
		{
			input:		ui.Form.BasicInputField;
			label?:		string;
			size:			ui.TwitterBootstrap3_3.IGridSize;
		}

		export abstract class Builder<T>
		{
			protected	m_Data: T;

			protected constructor( data: T )
			{
				this.m_Data	= data;
			}
		}

		export abstract class TabContentBuilder<T>
			extends ui.tab.TabHTMLPresentation
		{
			protected	m_Data: T;

			protected constructor( data: T )
			{
				super();

				this.m_Data	= data;
			}

			protected AddInput( container: ui.base.BaseHTMLElement, _form: ui.Form.Form, _input: IInputUIDefinition[] )
			{
				_input.forEach( ( def: IInputUIDefinition ) =>
					{
						const inputID = ui.utils.UUID.Gen();
						_form.Input( def.input );

						if ( def.label )
						{
							const label = new ui.base.BaseHTMLElement<HTMLLabelElement>( 'label' );

							label.text( def.label );

							label.attr( 'for', inputID );

							label.addClass( 'col-xs-' + ( 10 - def.size.xs >= 0 ? 12 - def.size.xs : 12 ) );
							label.addClass( 'col-sm-' + ( 10 - def.size.sm >= 0 ? 12 - def.size.sm : 12 ) );
							label.addClass( 'col-md-' + ( 10 - def.size.md >= 0 ? 12 - def.size.md : 12 ) );
							label.addClass( 'col-lg-' + ( 10 - def.size.lg >= 0 ? 12 - def.size.lg : 12 ) );

							container.append( label );
						}

						def.input.Base().addClass( 'col-xs-' + def.size.xs );
						def.input.Base().addClass( 'col-sm-' + def.size.sm );
						def.input.Base().addClass( 'col-md-' + def.size.md );
						def.input.Base().addClass( 'col-lg-' + def.size.lg );

						def.input.rebuild( container );
					}
				);
			}

		}

	}
}
